import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetInvoicePaymentInfoLazyQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/PublicBillingActionsRpc.hooks';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import Raven from 'raven-js';
import { Paths } from '../constants/Paths';
import { Metrics } from '../utils/Metrics';

// Needed to receive payment success message from Iframed checkout
function toIframeableUrl(url) {
  const parsed = new URL(url);
  if (!parsed.pathname.includes('/iframe/')) {
    if (!parsed.pathname.includes('/purchase/')) {
      Raven.captureMessage(`PayInvoicePage: unexpected payment URL pathname: ${parsed.pathname}`);
    }
    parsed.pathname = parsed.pathname.replace('/purchase/', '/iframe/purchase/');
  }
  return parsed.toString();
}
function buildPayInvoicePath(paymentUrl, invoiceId) {
  const formattedPaymentUrl = new URL(toIframeableUrl(paymentUrl));
  formattedPaymentUrl.searchParams.set('layout', 'billing-portal');
  const params = new URLSearchParams();
  params.set('url', formattedPaymentUrl.toString());
  if (invoiceId) {
    params.set('invoiceId', String(invoiceId));
  }
  return `${Paths.PAY_INVOICE}?${params.toString()}`;
}
export function usePayInvoice() {
  const history = useHistory();
  const pendingInvoiceIdRef = useRef(null);
  const [fetchPaymentInfo, {
    data,
    loading,
    error
  }] = useGetInvoicePaymentInfoLazyQuery({
    fetchPolicy: 'no-cache'
  });
  useEffect(() => {
    const paymentUrl = data === null || data === void 0 ? void 0 : data.paymentUrl;
    if (paymentUrl) {
      try {
        history.push(buildPayInvoicePath(paymentUrl, pendingInvoiceIdRef.current));
      } catch (e) {
        Raven.captureException(e instanceof Error ? e : new Error(String(e)));
      }
    }
  }, [data, history]);
  useEffect(() => {
    if (error) {
      Metrics.counter('pay-invoice-error').increment();
      FloatingAlertStore.addAlert({
        message: I18n.text('invoices.payNowError'),
        titleText: I18n.text('invoices.payNowErrorTitle'),
        type: 'danger'
      });
    }
  }, [error]);
  const payInvoice = crmInvoiceId => {
    pendingInvoiceIdRef.current = crmInvoiceId;
    Metrics.counter('pay-invoice-initiated').increment();
    fetchPaymentInfo({
      variables: {
        crmInvoiceId
      }
    });
  };
  return {
    payInvoice,
    loading
  };
}